export default __webpack_public_path__ + "static/media/soul-pink-light.4fef9f36.png";